import { useQuery } from "@tanstack/react-query";
import { Card } from "@rumbledirect/ui";
import { Empty, Typography } from "antd";
import dayjs from "dayjs";
import { fetchMessagesByAgentSessionId } from "../../../../lib/api/resources/agent";
import { AgentSession } from "@rumble-it/common-lib/types/models/AgentSession.interface";
import markdownit from "markdown-it";

const { Text } = Typography;

interface AgentDossierMessagesCardProps {
  selectedSession?: AgentSession | null;
}

export const AgentDossierMessagesCard = ({
  selectedSession,
}: AgentDossierMessagesCardProps) => {
  const messagesQuery = useQuery({
    queryKey: ["agentDossierMessages", selectedSession?.id],
    queryFn: async () => {
      if (!selectedSession?.id) {
        throw new Error("No session selected");
      }
      const messages = await fetchMessagesByAgentSessionId(
        selectedSession.id,
        selectedSession?.agentId,
      );
      return messages;
    },
    select: (data) => {
      return {
        ...data,
        member: data.member.slice(1),
      };
    },
    enabled: !!selectedSession?.id,
  });

  const md = markdownit({ html: true, breaks: true });

  const renderMarkdown = (content: string, role: "user" | "assistant") => {
    return (
      <Typography>
        <div
          style={{ color: role === "user" ? "rgb(255, 79, 20)" : "#000000" }}
          dangerouslySetInnerHTML={{ __html: md.render(content) }}
        />
      </Typography>
    );
  };

  return (
    <Card
      title="Berichten"
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
      }}
      loading={messagesQuery.isLoading}
    >
      {selectedSession?.id ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          {messagesQuery.data?.member?.map((message) => (
            <div
              key={message.id}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: message.role === "user" ? "flex-end" : "flex-start",
              }}
            >
              <div
                style={{
                  maxWidth: "70%",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  paddingBottom: 0,
                  backgroundColor:
                    message.role === "user" ? "#fff0e6" : "#f0f0f0",
                  color: message.role === "user" ? "rgb(255, 79, 20)" : "#000",
                }}
              >
                {message.content?.map((part, index) => (
                  <span key={index}>
                    {part.type === "text"
                      ? renderMarkdown(part.text, message.role)
                      : null}
                  </span>
                ))}
              </div>
              <Text
                type="secondary"
                style={{ fontSize: "11px", marginTop: "4px" }}
              >
                {dayjs(message.createdAt).format("DD-MM-YYYY HH:mm:ss")}
              </Text>
            </div>
          ))}
        </div>
      ) : (
        <Empty description="Selecteer een sessie om berichten te bekijken" />
      )}
    </Card>
  );
};
